import { combineReducers } from "redux";
import LoadingReducer from "./loadingReducer";
import {
  GETAGENTSFAILURE,
  GETAGENTSNAMESFAILURE,
  GETAGENTSNAMESSUCCESS,
  GETAGENTSSUCCESS,
  GETDISTRIBUTORFAILURE,
  GETDISTRIBUTORNAMESFAILURE,
  GETDISTRIBUTORNAMESSUCCESS,
  GETDISTRIBUTORSUCCESS,
  GETFASTAGFAILURE,
  GETFASTAGSUCCESS,
  GETINVENTORYAGENTFAILURE,
  GETINVENTORYAGENTSUCCESS,
  GETINVENTORYDISTRIBUTORFAILURE,
  GETINVENTORYDISTRIBUTORSUCCESS,
  GETINVENTORYFAILURE,
  GETINVENTORYSUCCESS,
  GETINVENTORYREQUEST,
  GETREPORTFAILURE,
  GETREPORTSUCCESS,
  GETSTATEFAILURE,
  GETSTATESUCCESS,
  GETCITYFAILURE,
  GETCITYSUCCESS,
  LOGINFAILURE,
  LOGINSUCCESS,
  SENDOTPFAILURE,
  SENDOTPSUCCESS,
  CHANGEPASSWORDREQUEST,
  CHANGEPASSWORDSUCCESS,
  CHANGEPASSWORDFAILURE,
  EDITDISTRIBUTORREQUEST,
  EDITDISTRIBUTORSUCCESS,
  EDITDISTRIBUTORFAILURE,
  GETMASTERFASTAGSUCCESS,
  GETMASTERFASTAGFAILURE,
  GETALLAGENTSNAMESSUCCESS,
  GETALLAGENTSNAMESFAILURE,
  GETINVENTORYSUMMARYSUCCESS,
  GETINVENTORYSUMMARYFAILURE,
  CREATEDISTRIBUTORBULKREQUEST,
  CREATEDISTRIBUTORBULKSUCCESS,
  CREATEDISTRIBUTORBULKFAILURE,
  CREATEAGENTBULKREQUEST,
  CREATEAGENTBULKSUCCESS,
  CREATEAGENTBULKFAILURE,
  GETDISTRIBUTORSUMMARYSUCCESS,
  GETDISTRIBUTORSUMMARYFAILURE,
  GETDISTRIBUTORAGENTSUMMARYSUCCESS,
  GETDISTRIBUTORAGENTSUMMARYFAILURE,
  GETAGENTSUMMARYSUCCESS,
  GETAGENTSUMMARYFAILURE,
  GETDISTRIBUTORREQUESTSUCCESS,
  GETDISTRIBUTORREQUESTFAILURE,
  ASSIGNAGENTEXCELREQUEST,
  ASSIGNAGENTEXCELSUCCESS,
  ASSIGNAGENTEXCELFAILURE,
  GETALLFASTAGAGENTREQUESTSUCCESS,
  GETALLFASTAGAGENTREQUESTFAILURE,
  GETAGENTFASTAGSUCCESS,
  GETAGENTFASTAGFAILURE,
  UPDATEAGENTREQUESTSTATUSREQUEST,
  UPDATEAGENTREQUESTSTATUSSUCCESS,
  UPDATEAGENTREQUESTSTATUSFAILURE,
  DENIEDREQUESTSTATUSREQUEST,
  DENIEDREQUESTSTATUSSUCCESS,
  DENIEDREQUESTSTATUSFAILURE,
  ASSIGNDISTRIBUTOREXCELREQUEST,
  ASSIGNDISTRIBUTOREXCELSUCCESS,
  ASSIGNDISTRIBUTOREXCELFAILURE,
  GET_AGENTS_DISTRIBUTOR_WISE_REQUEST,
  GET_AGENTS_DISTRIBUTOR_WISE_SUCCESS,
  GET_AGENTS_DISTRIBUTOR_WISE_FAILURE,
  LOGOUT,
  REFRESH_DATA,
} from "./actionTypes";

const INITIAL_STATE = {
  LoginData: {},
};


const LoginReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGINSUCCESS:
      return {
        ...state,
        LoginData: action.payload,
      };
    case LOGINFAILURE:
      return {
        ...state,
        LoginData: action.payload,
      };
    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}

const GetInventoryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETINVENTORYREQUEST:
      return {
        ...state,
        GetInventoryData: null,
      };
    case GETINVENTORYSUCCESS:
      return {
        ...state,
        GetInventoryData: action.payload,
      };
    case GETINVENTORYFAILURE:
      return {
        ...state,
        GetInventoryData: action.payload,
      };
    default:
      return state;
  }
}

const GetReportReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETREPORTSUCCESS:
      return {
        ...state,
        GetReportData: action.payload,
      };
    case GETREPORTFAILURE:
      return {
        ...state,
        GetReportData: action.payload,
      };
    default:
      return state;
  }
}

const GetFastagReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETFASTAGSUCCESS:
      return {
        ...state,
        GetFastagData: action.payload,
      };
    case GETFASTAGFAILURE:
      return {
        ...state,
        GetFastagData: action.payload,
      };
    default:
      return state;
  }
}
const GetAgentsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETAGENTSSUCCESS:
      return {
        ...state,
        GetAgentsData: action.payload,
      };
    case GETAGENTSFAILURE:
      return {
        ...state,
        GetAgentsData: action.payload,
      };
    default:
      return state;
  }
}
const GetAgentsNamesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETAGENTSNAMESSUCCESS:
      return {
        ...state,
        GetAgentsNamesData: action.payload,
      };
    case GETAGENTSNAMESFAILURE:
      return {
        ...state,
        GetAgentsNamesData: action.payload,
      };
    default:
      return state;
  }
}
const GetAllAgentsNamesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETALLAGENTSNAMESSUCCESS:
      return {
        ...state,
        GetAllAgentsNamesData: action.payload,
      };
    case GETALLAGENTSNAMESFAILURE:
      return {
        ...state,
        GetAllAgentsNamesData: action.payload,
      };
    default:
      return state;
  }
}


const GetInventoryDistributorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETINVENTORYDISTRIBUTORSUCCESS:
      return {
        ...state,
        GetInventoryDistributorData: action.payload,
      };
    case GETINVENTORYDISTRIBUTORFAILURE:
      return {
        ...state,
        GetInventoryDistributorData: action.payload,
      };
    default:
      return state;
  }
}

const GetDistributorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETDISTRIBUTORSUCCESS:
      return {
        ...state,
        GetDistributorData: action.payload,
      };
    case GETDISTRIBUTORFAILURE:
      return {
        ...state,
        GetDistributorData: action.payload,
      };
    default:
      return state;
  }
}
const GetDistributorNamesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETDISTRIBUTORNAMESSUCCESS:
      return {
        ...state,
        GetDistributorNamesData: action.payload,
      };
    case GETDISTRIBUTORNAMESFAILURE:
      return {
        ...state,
        GetDistributorNamesData: action.payload,
      };
    default:
      return state;
  }
}

const GetInventoryAgentReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETINVENTORYAGENTSUCCESS:
      return {
        ...state,
        GetInventoryAgentData: action.payload,
      };
    case GETINVENTORYAGENTFAILURE:
      return {
        ...state,
        GetInventoryAgentData: action.payload,
      };
    default:
      return state;
  }
}

const GetStateReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case GETSTATESUCCESS:
      return {
        ...state,
        GetStateData: action.payload,
      };
    case GETSTATEFAILURE:
      return {
        ...state,
        GetStateData: action.payload,
      };
    default:
      return state;
  }
}

const GetCityReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case GETCITYSUCCESS:
      return {
        ...state,
        GetCityData: action.payload,
      };
    case GETCITYFAILURE:
      return {
        ...state,
        GetCityData: action.payload,
      };
    default:
      return state;
  }
}

const SendOtpReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SENDOTPSUCCESS:
      return {
        ...state,
        SendOtpData: action.payload,
      };
    case SENDOTPFAILURE:
      return {
        ...state,
        SendOtpData: action.payload,
      };
    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}

const ChangePasswordReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CHANGEPASSWORDREQUEST:
      return {
        ...state,
        ChangePasswordLoading: true,
        ChangePasswordData: null,
      };
    case CHANGEPASSWORDSUCCESS:
      return {
        ...state,
        ChangePasswordLoading: false,
        ChangePasswordData: action.payload,
      };
    case CHANGEPASSWORDFAILURE:
      return {
        ...state,
        ChangePasswordLoading: false,
        ChangePasswordData: action.payload,
      };
    default:
      return state;
  }
}

const EditDistributorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EDITDISTRIBUTORREQUEST:
      return {
        ...state,
        EditDistributorLoading: true,
        EditDistributorData: null,
      };
    case EDITDISTRIBUTORSUCCESS:
      return {
        ...state,
        EditDistributorLoading: false,
        EditDistributorData: action.payload,
      };
    case EDITDISTRIBUTORFAILURE:
      return {
        ...state,
        EditDistributorLoading: false,
        EditDistributorData: action.payload,
      };
    default:
      return state;
  }
}

const GetMasterFastagReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETMASTERFASTAGSUCCESS:
      return {
        ...state,
        GetMasterFastagData: action.payload,
      };
    case GETMASTERFASTAGFAILURE:
      return {
        ...state,
        GetMasterFastagData: action.payload,
      };
    default:
      return state;
  }
}

const GetInventorySummaryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETINVENTORYSUMMARYSUCCESS:
      return {
        ...state,
        GetInventorySummaryData: action.payload,
      };
    case GETINVENTORYSUMMARYFAILURE:
      return {
        ...state,
        GetInventorySummaryData: action.payload,
      };
    default:
      return state;
  }
}

const CreateDistributorBulkReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATEDISTRIBUTORBULKREQUEST:
      return {
        ...state,
        CreateDistributorBulkLoading: true,
        CreateDistributorBulkData: null,
      };
    case CREATEDISTRIBUTORBULKSUCCESS:
      return {
        ...state,
        CreateDistributorBulkLoading: false,
        CreateDistributorBulkData: action.payload,
      };
    case CREATEDISTRIBUTORBULKFAILURE:
      return {
        ...state,
        CreateDistributorBulkLoading: false,
        CreateDistributorBulkData: action.payload,
      };
    default:
      return state;
  }
}

const CreateAgentBulkReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATEAGENTBULKREQUEST:
      return {
        ...state,
        CreateAgentBulkLoading: true,
        CreateAgentBulkSuccess: false,
        CreateAgentBulkError: null,
        CreateAgentBulkData: null,
      };
    case CREATEAGENTBULKSUCCESS:
      return {
        ...state,
        CreateAgentBulkLoading: false,
        CreateAgentBulkSuccess: true,
        CreateAgentBulkError: null,
        CreateAgentBulkData: action.payload,
      };
    case CREATEAGENTBULKFAILURE:
      return {
        ...state,
        CreateAgentBulkLoading: false,
        CreateAgentBulkSuccess: false,
        CreateAgentBulkError: action.payload.error || action.payload,
        CreateAgentBulkData: null,
      };
    default:
      return state;
  }
}

const GetDistributorSummaryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETDISTRIBUTORSUMMARYSUCCESS:
      return {
        ...state,
        GetDistributorSummaryData: action.payload,
      };
    case GETDISTRIBUTORSUMMARYFAILURE:
      return {
        ...state,
        GetDistributorSummaryData: action.payload,
      };
    default:
      return state;
  }
}

const GetDistributorAgentSummaryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETDISTRIBUTORAGENTSUMMARYSUCCESS:
      return {
        ...state,
        GetDistributorAgentSummaryData: action.payload,
      };
    case GETDISTRIBUTORAGENTSUMMARYFAILURE:
      return {
        ...state,
        GetDistributorAgentSummaryData: action.payload,
      };
    default:
      return state;
  }
}

const GetAgentSummaryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETAGENTSUMMARYSUCCESS:
      return {
        ...state,
        GetAgentSummaryData: action.payload,
      };
    case GETAGENTSUMMARYFAILURE:
      return {
        ...state,
        GetAgentSummaryData: action.payload,
      };
    default:
      return state;
  }
}

const GetDistributorRequestReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETDISTRIBUTORREQUESTSUCCESS:
      return {
        ...state,
        GetDistributorRequestData: action.payload,
      };
    case GETDISTRIBUTORREQUESTFAILURE:
      return {
        ...state,
        GetDistributorRequestData: action.payload,
      };
    default:
      return state;
  }
}

const AssignAgentExcelReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ASSIGNAGENTEXCELREQUEST:
      return {
        ...state,
        AssignAgentExcelLoading: true,
        AssignAgentExcelData: null,
        AssignAgentExcelError: null,
      };
    case ASSIGNAGENTEXCELSUCCESS:
      return {
        ...state,
        AssignAgentExcelLoading: false,
        AssignAgentExcelData: action.payload,
        AssignAgentExcelError: null,
      };
    case ASSIGNAGENTEXCELFAILURE:
      return {
        ...state,
        AssignAgentExcelLoading: false,
        AssignAgentExcelData: null,
        AssignAgentExcelError: action.payload,
      };
    default:
      return state;
  }
}

const GetAllFastagAgentRequestReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETALLFASTAGAGENTREQUESTSUCCESS:
      return {
        ...state,
        GetAllFastagAgentRequestData: action.payload,
      };
    case GETALLFASTAGAGENTREQUESTFAILURE:
      return {
        ...state,
        GetAllFastagAgentRequestData: action.payload,
      };
    default:
      return state;
  }
}

const GetAgentFastagReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GETAGENTFASTAGSUCCESS:
      return {
        ...state,
        GetAgentFastagData: action.payload,
      };
    case GETAGENTFASTAGFAILURE:
      return {
        ...state,
        GetAgentFastagData: action.payload,
      };
    default:
      return state;
  }
}

const UpdateAgentRequestStatusReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATEAGENTREQUESTSTATUSREQUEST:
      return {
        ...state,
        UpdateAgentRequestStatusLoading: true,
        UpdateAgentRequestStatusData: null,
      };
    case UPDATEAGENTREQUESTSTATUSSUCCESS:
      return {
        ...state,
        UpdateAgentRequestStatusLoading: false,
        UpdateAgentRequestStatusData: action.payload,
      };
    case UPDATEAGENTREQUESTSTATUSFAILURE:
      return {
        ...state,
        UpdateAgentRequestStatusLoading: false,
        UpdateAgentRequestStatusData: action.payload,
      };
    default:
      return state;
  }
}

const DeniedRequestReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DENIEDREQUESTSTATUSREQUEST:
      return {
        ...state,
        DeniedRequestLoading: true,
        DeniedRequestData: null,
      };
    case DENIEDREQUESTSTATUSSUCCESS:
      return {
        ...state,
        DeniedRequestLoading: false,
        DeniedRequestData: action.payload,
      };
    case DENIEDREQUESTSTATUSFAILURE:
      return {
        ...state,
        DeniedRequestLoading: false,
        DeniedRequestData: action.payload,
      };
    default:
      return state;
  }
}

const AssignDistributorExcelReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ASSIGNDISTRIBUTOREXCELREQUEST:
      return {
        ...state,
        AssignDistributorExcelLoading: true,
        AssignDistributorExcelData: null,
        AssignDistributorExcelError: null,
      };
    case ASSIGNDISTRIBUTOREXCELSUCCESS:
      return {
        ...state,
        AssignDistributorExcelLoading: false,
        AssignDistributorExcelData: action.payload,
        AssignDistributorExcelError: null,
      };
    case ASSIGNDISTRIBUTOREXCELFAILURE:
      return {
        ...state,
        AssignDistributorExcelLoading: false,
        AssignDistributorExcelData: null,
        AssignDistributorExcelError: action.payload,
      };
    default:
      return state;
  }
}

const GetAgentsDistributorWiseReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_AGENTS_DISTRIBUTOR_WISE_REQUEST:
      return {
        ...state,
        GetAgentsDistributorWiseLoading: true,
      };
    case GET_AGENTS_DISTRIBUTOR_WISE_SUCCESS:
      return {
        ...state,
        GetAgentsDistributorWiseLoading: false,
        GetAgentsDistributorWiseData: action.payload,
      };
    case GET_AGENTS_DISTRIBUTOR_WISE_FAILURE:
      return {
        ...state,
        GetAgentsDistributorWiseLoading: false,
        GetAgentsDistributorWiseData: action.payload,
      };
    default:
      return state;
  }
}

const RefreshReducer = (state = { refreshCount: 0 }, action) => {
  switch (action.type) {
    case REFRESH_DATA:
      return {
        ...state,
        refreshCount: state.refreshCount + 1,
      };
    default:
      return state;
  }
}

export default combineReducers({
  Login: LoginReducer,
  GetInventory: GetInventoryReducer,
  GetReport: GetReportReducer,
  GetFastag: GetFastagReducer,
  GetAgents: GetAgentsReducer,
  GetAgentsNames: GetAgentsNamesReducer,
  GetInventoryDistributor: GetInventoryDistributorReducer,
  GetDistributor: GetDistributorReducer,
  GetDistributorNames: GetDistributorNamesReducer,
  GetInventoryAgent: GetInventoryAgentReducer,
  GetState: GetStateReducer,
  GetCity: GetCityReducer,
  SendOtp: SendOtpReducer,
  ChangePassword: ChangePasswordReducer,
  EditDistributor: EditDistributorReducer,
  GetMasterFastag: GetMasterFastagReducer,
  GetAllAgentsNames: GetAllAgentsNamesReducer,
  GetInventorySummary: GetInventorySummaryReducer,
  CreateDistributorBulk: CreateDistributorBulkReducer,
  CreateAgentBulk: CreateAgentBulkReducer,
  GetDistributorSummary: GetDistributorSummaryReducer,
  GetDistributorAgentSummary: GetDistributorAgentSummaryReducer,
  GetAgentSummary: GetAgentSummaryReducer,
  GetDistributorRequest: GetDistributorRequestReducer,
  AssignAgentExcel: AssignAgentExcelReducer,
  GetAllFastagAgentRequest: GetAllFastagAgentRequestReducer,
  GetAgentFastag: GetAgentFastagReducer,
  UpdateAgentRequestStatus: UpdateAgentRequestStatusReducer,
  DeniedRequest: DeniedRequestReducer,
  AssignDistributorExcel: AssignDistributorExcelReducer,
  GetAgentsDistributorWise: GetAgentsDistributorWiseReducer,
  Loading: LoadingReducer,
  Refresh: RefreshReducer
});

